import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const [error, setError] = useState(false);

  useEffect(() => {
    const hash = window.location.hash || "";
    const search = window.location.search || "";
    let sessionId = null;
    const h = new URLSearchParams(hash.replace(/^#/, ""));
    sessionId = h.get("session_id") || new URLSearchParams(search).get("session_id");
    if (!sessionId) {
      setError(true);
      setTimeout(() => navigate("/"), 1500);
      return;
    }
    googleLogin(sessionId)
      .then(() => navigate("/generate"))
      .catch(() => {
        setError(true);
        setTimeout(() => navigate("/"), 1800);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-canvas flex flex-col items-center justify-center text-center px-4">
      <LogoMark size={44} />
      <div className="mt-6">
        {error ? (
          <p className="text-ink-muted">Sign-in failed. Redirecting…</p>
        ) : (
          <>
            <Loader2 className="animate-spin text-brand mx-auto" size={30} />
            <p className="text-ink-muted mt-4">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
